import { render, staticRenderFns } from "./UserTickets.vue?vue&type=template&id=32edd132&"
import script from "./UserTickets.vue?vue&type=script&lang=js&"
export * from "./UserTickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports